import { render, staticRenderFns } from "./groundOil.vue?vue&type=template&id=4cda9264&scoped=true"
import script from "./groundOil.vue?vue&type=script&lang=js"
export * from "./groundOil.vue?vue&type=script&lang=js"
import style0 from "./groundOil.vue?vue&type=style&index=0&id=4cda9264&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cda9264",
  null
  
)

export default component.exports